
import { supabase } from "@/integrations/supabase/client";
import { TravelConstraints } from '../mappings/TravelDistanceMapping';
import { applyTravelDistanceFilter, getTravelDistanceMessage } from '../filters/TravelDistanceFilter';
import { applyPriceFilter } from '../filters/PriceFilter';
import { applyFacilitiesFilter } from '../filters/FacilitiesFilter';
import { verifyAndFilterResults } from '../utils/ResultsVerification';

export const handleTravelConstraintSearch = async (
  travelConstraints: TravelConstraints,
  priceConstraints: any,
  detectedFacilities: any,
  query: string
) => {
  console.log('🛫 === USING TRAVEL DISTANCE AS PRIMARY FILTER ===');
  
  let dbQuery = supabase
    .from('Complete feed')
    .select('*')
    .not('imageURL', 'is', null)
    .not('name', 'is', null);

  // Apply travel distance filter
  dbQuery = applyTravelDistanceFilter(dbQuery, travelConstraints);

  // Apply additional filters
  if (priceConstraints) {
    console.log('💰 === APPLYING PRICE FILTERS ===');
    dbQuery = applyPriceFilter(dbQuery, priceConstraints);
  }

  if (detectedFacilities) {
    console.log('🏨 === APPLYING FACILITIES FILTERS ===');
    dbQuery = applyFacilitiesFilter(dbQuery, detectedFacilities);
  }

  // Execute query
  const { data, error } = await dbQuery.limit(100);
  
  if (error) {
    console.error('❌ Travel distance search error:', error);
    throw error;
  }
  
  const travelMessage = getTravelDistanceMessage(travelConstraints);
  console.log(`🛫 Travel distance search found ${data?.length || 0} results for "${travelMessage}"`);
  
  // Add travel context to results
  const resultsWithContext = (data || []).map(vacation => ({
    ...vacation,
    travelContext: {
      constraints: travelConstraints,
      message: travelMessage
    }
  }));
  
  return verifyAndFilterResults(resultsWithContext, null, priceConstraints, detectedFacilities, query);
};
